module.exports = __webpack_public_path__ + "static/media/duo-print.dd618d04.png";